import type { DeliveryGroupDraft } from './deliveryGroupTypes';
import { resolveGroupApplicationIds } from './deliveryGroupModel';
import { isGroupPrimaryPhysicalSourceReady } from './groupPhysicalSourceFlow';

export type GroupValidationIssue = {
  code:
    | 'GROUP_ORPHAN_UNLOADING'
    | 'GROUP_MISSING_APPLICATION'
    | 'GROUP_MISSING_PHYSICAL_SOURCE'
    | 'GROUP_CROSS_OWNERSHIP'
    | 'GROUP_EMPTY';
  groupUid: string;
  message: string;
};

export function validateDeliveryGroups(groups: DeliveryGroupDraft[]): GroupValidationIssue[] {
  const issues: GroupValidationIssue[] = [];

  for (let index = 0; index < groups.length; index++) {
    const group = groups[index];
    const groupLabel =
      group.label ||
      (group.applicationId ? `группа ${index + 1}` : `группа маршрута ${index + 1}`);

    if (group.loadingStops.length === 0 && group.unloadingStops.length > 0) {
      issues.push({
        code: 'GROUP_ORPHAN_UNLOADING',
        groupUid: group.uid,
        message: `В «${groupLabel}» есть выгрузка без точки погрузки`
      });
    }

    const appIds = resolveGroupApplicationIds(group);
    const hasWarehouseLoading = group.loadingStops.some(
      (s) => s.pointType === 'warehouse' && s.pointId
    );
    if (appIds.size === 0 && !hasWarehouseLoading) {
      issues.push({
        code: 'GROUP_MISSING_APPLICATION',
        groupUid: group.uid,
        message: `Для «${groupLabel}» выберите заявку`
      });
    }
    if (appIds.size === 0 && hasWarehouseLoading) {
      issues.push({
        code: 'GROUP_MISSING_APPLICATION',
        groupUid: group.uid,
        message: `Для «${groupLabel}» выберите заявку (склад без заявки недопустим, RC-1)`
      });
    }
    if (group.applicationId && !isGroupPrimaryPhysicalSourceReady(group)) {
      issues.push({
        code: 'GROUP_MISSING_PHYSICAL_SOURCE',
        groupUid: group.uid,
        message: `Для «${groupLabel}» выберите физический источник груза (CP-059)`
      });
    }

    if (group.loadingStops.length === 0 && group.unloadingStops.length === 0 && !group.applicationId) {
      issues.push({
        code: 'GROUP_EMPTY',
        groupUid: group.uid,
        message: `«${groupLabel}» пуста — добавьте заявку и точки маршрута`
      });
    }
  }

  return issues;
}
